import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useShootboltSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);
  const material = useStore((state) => state.quote.material);

  const isAlumBifold = doorType?.includes("Bi-fold") && material === "All Aluminum"

  const shootBoltColor = useStore((state) => state.quote.shootBoltColor);

  const stilesAndRails = useStore((state) => state.quote.stilesAndRails);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    if (checked) {
      addToQuote({ shootBoltColor: "" }, "shootBoltColor");
    } else {
      addToQuote({ shootBoltColor: label });
      if (findRequired("Shoot Bolt Color")) removeRequired("Shoot Bolt Color");
    }
  };

  const variant = (label: string) =>
    label === shootBoltColor ? "filled" : "outlined";

  const checkMark = (label: string) => label === shootBoltColor;

  return {
    variant,
    checkMark,
    handleClick,
    stilesAndRails,
    isAlumBifold
  };
}

export default useShootboltSelector;
